export default __webpack_public_path__ + "static/media/1cha.63bc349b.svg";